import Page from './index';

export default { path: '/home/tenant/coin', component: Page };
